import React from "react";
import {
  Box,
  Heading,
  Text,
  VStack,
  SimpleGrid,
  Grid,
  GridItem,
  Icon,
  Avatar,
} from "@chakra-ui/react";
import { FaCircle } from "react-icons/fa6";
import { motion } from "framer-motion";

const MotionBox = motion(Box);

const TimelineCard = ({
  institution,
  year,
  role,
  description,
  side,
  logoUrl,
}) => {
  return (
    <MotionBox
      initial={{ opacity: 0, x: side === "left" ? -100 : 100 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
    >
      <Box
        borderWidth="2px"
        borderColor="#FFE2FF"
        borderRadius="lg"
        overflow="hidden"
        p={4}
        boxShadow="md"
        background="#530054"
        
      >
        <VStack align="start" spacing={2}>
          <Avatar src={logoUrl} name={institution} />
          <Heading size="sm">{institution}</Heading>
          <Text fontSize="sm" color="#FF15F5">
            {year}
          </Text>

          <Text fontSize="md" fontWeight="bold" color="#F74C06">
            {role}
          </Text>
          <Text fontSize="lg">{description}</Text>
        </VStack>
      </Box>
    </MotionBox>
  );
};

const TimeLine = ({ items }) => {
  return (
    <Box pb={8}>
      <Grid  templateColumns={{ base: "1fr", md: "1fr", lg: "1fr 1px 1fr" }}  gap={10} position="relative">
        {items.map((item, index) => (
          <GridItem key={index} colSpan={1}  colStart={{ base: 1, md: 1, lg: index % 2 === 0 ? 1 : 3 }}>
            <TimelineCard
              institution={item.institution}
              year={item.year}
              role={item.role}
              description={item.description}
              side={index % 2 === 0 ? "left" : "right"}
              logoUrl={item.logoUrl}
            />
          </GridItem>
        ))}
        <GridItem colSpan={1} colStart={2} height="100%"  display={{ base: "none", md: "none", lg: "block" }}>
          <Box
            position="absolute"
            top={0}
            bottom={10}
            left="50%"
            width="2px"
            bg="#fff"
            transform="translateX(-50%)"
          >
            {/* Add an icon along the separating line */}
            {/* {items.map((item, index) => (
              (index % 2 === 0 && index !== 0) && (
                <Icon
                  key={index}
                  as={FaCircle}
                  boxSize={3}
                  color="#fff"
                  position="absolute"
                  top={`calc(${index / 2} * (100% / ${(items.length *5) / 2}))`}
                  left="50%"
                  transform="translateX(-50%)"
                />
              )
            ))} */}
            {items.map((item, index) => (
              <Icon
                key={index}
                as={FaCircle}
                boxSize={3}
                color="#fff"
                position="absolute"
                top={`${(index) / items.length}%`}
                left="50%"
                transform="translateX(-50%)"
              />
            ))}
          </Box>
        </GridItem>
      </Grid>
    </Box>
  );
};

export default TimeLine;
